import { render, staticRenderFns } from "./ProfileStatus.vue?vue&type=template&id=7149679c&"
import script from "./ProfileStatus.vue?vue&type=script&lang=js&"
export * from "./ProfileStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports